import { ChannelItemDirection } from '../enums/ChannelItemDirection';
import { ChannelItemType } from '../enums/ChannelItemType';
import { ChannelType } from '../enums/ChannelType';
import { ContactFieldValue } from './ContactField';

export interface InboxItem {
    contactId: number;
    status: InboxItemStatus;
    firstName: string | undefined;
    lastName: string | undefined;
    salutation: ContactFieldValue;
    phone: string;
    type: ChannelType;
    lastDate: string; //~ ISO date & time string
    startDate: string; //~ ISO date & time string
    subType: ChannelItemType;
    direction: ChannelItemDirection;
    userName: string;
    channelId: number;
    text: string; //~ used for message preview
    unreadCount: number;
}

export enum InboxItemStatus {
    Cold = 0,
    Hot = 1,
    Pending = 2,
}

export interface InboxFilter {
    id: number | null;
    name: string;
    filter: InboxFiltersOptions;
    isDefault: boolean;
}

export interface InboxFiltersOptions {
    search: string;
    channels: ChannelType[];
    direction: InboxFilterDirection;
    channelsRange: DateRange;
    registrationRange: DateRange;
    activityRange: DateRange;
    ownershipScope: OwnershipScope;
    sort: InboxSort;
}

export interface InboxSort {
    field: InboxFiledSortType;
    direction: SortDirection;
}

export interface InboxFilterOptions {
    search: string;
    channels: ChannelType[];
    direction: InboxFilterDirection;
    channelsRange: DateRange;
    registrationRange: DateRange;
    activityRange: DateRange;
    ownershipScope: OwnershipScope;
    sort: InboxSort;
}

export enum DateRange {
    None = 0,
    Today = 1,
    Yesterday = 2,
    Last3Days = 3,
    Last7Days = 4,
    Last14Days = 5,
    Last30Days = 6,
    Last45Days = 7,
    Last60Days = 8,
    Last90Days = 9,
    Older90Days = 10,
    Older180Days = 11,
}

export enum OwnershipScope {
    All = 0,
    Owner = 1,
    Follower = 2,
}

export enum InboxFiledSortType {
    ActivityDate = 0,
    ChannelDate = 1,
    RegistrationDate = 2,
    FirstName = 3,
    LastName = 4,
}

export enum SortDirection {
    Ascending = 0,
    Descending = 1,
}

export enum InboxFilterDirection {
    incoming = 0,
    outgoing = 1,
    none = 2,
}
